import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numeroProcessoPipe'
})
export class NumeroProcessoPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {

    let resultado: any;

    if (value) {

      value = value.toString();
      resultado = value.split('');
      const tamanho = resultado.length;

      switch (tamanho) {
        case 7: resultado.splice(7, 0, '-'); break;
        case 10: resultado.splice(10, 0, '.'); break;
        case 15: resultado.splice(15, 0, '.'); break;
        case 17: resultado.splice(17, 0, '.'); break;
        // case 20: resultado.splice(20, 0, '.'); break;
      }

      value = resultado.join('');

    }

    return value;

  }

}
